
import React from 'react';
import { RefreshCw, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface RemediationHeaderProps {
  paperCount: number;
  loading: boolean;
  refreshing: boolean;
  onRefresh: () => void;
}

const RemediationHeader: React.FC<RemediationHeaderProps> = ({
  paperCount,
  loading,
  refreshing,
  onRefresh
}) => {
  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold">Content Remediation</h2>
          <p className="text-muted-foreground">
            Fix papers with PDFs but missing AI reviews, keywords, or research information
          </p>
        </div>
        <Button 
          onClick={onRefresh} 
          disabled={refreshing} 
          size="sm" 
          className="gap-1"
        >
          <RefreshCw className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} />
          Refresh
        </Button>
      </div>

      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Papers Needing Remediation
            <Badge variant="outline" className="ml-2">
              {loading ? '...' : paperCount}
            </Badge>
          </CardTitle>
        </CardHeader>
      </Card>
    </>
  );
};

export default RemediationHeader;
